import React from "react";
import styled from "styled-components";

import { InfoMessage } from "@ui/Molecules";
import { Button } from "@ui/Atoms";
import { rem } from "@ui/helpers";

interface Props {
  onButtonClick: () => void;
  titleText: string;
  descriptionText: string;
  buttonText: string;
}

const ActionBox = (props: Props) => (
  <Wrapper>
    <Title>{props.titleText}</Title>
    <InfoMessageWrapper>
      <InfoMessage message={props.descriptionText} />
    </InfoMessageWrapper>
    <ButtonStyled
      variant="borderBlue"
      size="base"
      onClick={props.onButtonClick}
    >
      {props.buttonText}
    </ButtonStyled>
  </Wrapper>
);

export { ActionBox };

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.margins.base_x4};
  border: ${rem(1)} solid ${props => props.theme.palette.grey300};
  border-radius: ${props => props.theme.buttons.borderRadius};
  height: 100%;
`;

const InfoMessageWrapper = styled.div`
  margin-bottom: ${props => props.theme.margins.base_x4};
`;

const Title = styled.span`
  margin-bottom: ${props => props.theme.margins.base_x2};
  font-size: ${props => props.theme.fonts.sizes.subtitle};
  font-weight: ${props => props.theme.fonts.weights.bold};
`;

const ButtonStyled = styled(Button)`
  margin: auto 0 0 auto;
`;
